import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';

import {Notifications} from '../../icons/index';

import ActionTemplate from './ActionTemplate';

import style from './style';

class NotificationsHeaderAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    const {classes} = this.props;
    const {isOpen} = this.state;
    return (
      <ActionTemplate
        actionName={I18n.t('headerUser.notificationsOption.name')}
        classes={classes}
        handleClick={() => {}}
        handleClose={() => {}}
        icon={<Notifications className={classes.links} />}
        isOpen={isOpen}
      >
        <div />
      </ActionTemplate>
    );
  }
}

NotificationsHeaderAction.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(NotificationsHeaderAction);
